import platform from 'platform';

const isMobile = {
	Android: function() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function() {
		return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
	},
	any: function() {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	}
};

const JobDetail = () => {

	Array.from(document.querySelectorAll('.job-detail .arrow-back')).forEach(item => {
		if (!document.referrer || document.referrer.indexOf(item.getAttribute('href')) < 0) {
			return false;
		}

		item.addEventListener('click', event => {
			event.preventDefault();
			window.history.go(-1);
			return false;
		});
	});

	Array.from(document.getElementsByClassName('arrow-forward--callback')).forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();
			document.getElementById('callback-form-url').value = document.location.href;
			Array.from(document.getElementsByClassName('callback-form-container')).forEach(child => {
				child.classList.toggle('callback-form-container--visible');
			});
			return false;
		});
	});

	Array.from(document.getElementsByClassName('arrow-forward--apply')).forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();
			window.open(item.getAttribute('href'), 'ApplyWindow', 'width=600,height=500,scrollbars=yes');
			return false;
		});
	});

	Array.from(document.getElementsByClassName('arrow-forward--print')).forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();
			window.print();
			return false;
		});
	});

	Array.from(document.querySelectorAll('[data-share]')).forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();
			window.open(item.getAttribute('data-share'), 'ShareWindow', 'width=600,height=500,scrollbars=yes');
			return false;
		});
	});

	Array.from(document.querySelectorAll('[data-whatsapp-share]')).forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();

			const text = item.getAttribute('data-whatsapp-share');
			let link = `https://web.whatsapp.com/send?text=${text}`;

			if (platform.name === 'Chrome' || isMobile.any()) {
				link = `https://api.whatsapp.com/send?text=${text}`;
			}

			window.open(link, 'ShareWindow', 'width=600,height=500,scrollbars=yes');
			return false;
		});
	});

};

export default JobDetail;
